let singleton = Symbol();
let singletonEnforcer = Symbol();


class BlazyManager {
	static get instance() {
		if (!this[singleton]) {
			this[singleton] = new BlazyManager(singletonEnforcer);

			this[singleton].blazyInstance = new Blazy({loadInvisible: false});
		}

		return this[singleton].blazyInstance;
	}




	constructor(enforcer) {
		if (enforcer != singletonEnforcer) throw new Error("Cannot construct singleton");
	}
}

export default BlazyManager.instance;
